'use strict';

import 'angular';

import './style.css';
import toolbarDirective from './toolbar';
import item from './item';

var MODULE_NAME = 'daupler.incidents.components.actionToolbar';

var app = angular.module(MODULE_NAME, [
]);
app.directive('actionToolbar', toolbarDirective);
app.directive('actionToolbarCall', item({icon: '&#xE0CD;', text: 'Call'}));
app.directive('actionToolbarDelete', item({icon: '&#xE872;', text: 'Delete'}));
app.directive('actionToolbarUpdate', item({icon: '&#xE3C9;', text: 'Edit'}));

export default MODULE_NAME;
